export default "__VITE_ASSET__1suTKSx7__"